import React from 'react';
import { StyleSheet, View } from '@react-pdf/renderer';

import DataOneLinerPrintSummary from './DataOneLinerPrintSummary';

const DataBarGraphPrintSummary = ({
  label,
  percent,
  value = null,
  primaryBrand,
}): JSX.Element => {
  const height = 3;
  const Styles = StyleSheet.create({
    componentView: {
      marginBottom: 6.75,
    },
    onelinerView: {
      width: '100%',
      height: 12.5,
    },
    graphView: {
      width: '100%',
      height,
      borderRadius: 3,
      position: 'relative',
      overflow: 'hidden',
    },
    foregroundView: {
      width: `${(isNaN(percent as number)) ? 0 : percent}%`,
      height,
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: primaryBrand.colors.primary,
    },
    backgroundView: {
      width: '100%',
      height,
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: primaryBrand.colors.light,
    },
  });

  const _value = (value !== null) ? value.toFixed(0) : (parseFloat(`${percent}`).toFixed(2) + '%');

  return (
    <View style={Styles.componentView}>
      <View style={Styles.onelinerView}>
        <DataOneLinerPrintSummary
          label={label}
          value={_value}
          primaryBrand={primaryBrand}
        />
      </View>
      <View style={Styles.graphView}>
        <View style={Styles.backgroundView}></View>
        <View style={Styles.foregroundView}></View>
      </View>
    </View>
  );
};

export default DataBarGraphPrintSummary;
